import { ref } from 'vue'

interface Notification {
  show: boolean
  type: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
}

const notification = ref<Notification>({
  show: false,
  type: 'success',
  title: '',
  message: ''
})

export function useNotification() {
  const showSuccessInfo = (message: string, title: string = '任务领取成功') => {
    notification.value = {
      show: true,
      type: 'success',
      title,
      message
    }
  }

  const showErrorInfo = (message: string, title: string = '错误') => {
    notification.value = {
      show: true,
      type: 'error',
      title,
      message
    }
  }

  const showWarningInfo = (message: string, title: string = '警告') => {
    notification.value = {
      show: true,
      type: 'warning',
      title,
      message
    }
  }

  const showInfo = (message: string, title: string = '提示') => {
    notification.value = {
      show: true,
      type: 'info',
      title,
      message
    }
  }

  const close = () => {
    notification.value.show = false
  }

  return {
    notification,
    showSuccessInfo,
    showErrorInfo,
    showWarningInfo,
    showInfo,
    close
  }
} 